import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  parts: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('parts');


const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.parts.length > 0 ? action.parts : [];
  return updateObject(state, {
    parts: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, parts: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PARTS_START:
      return fetchStart(state);
    case actionTypes.FETCH_PARTS_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_PARTS_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
